import { rem } from 'polished'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import LuxPlusLogo from 'luxPlus/components/Logos/LuxPlusLogo'

const Banner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${rem(16)};
  background: linear-gradient(96deg, #304dab 14.36%, #4c82df 85.9%);
  color: ${props => props.theme.palette.neutral.surface.staticWhite};
  padding: ${rem(20)};
  border-radius: ${rem(8)};
`

const Copy = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(2)};
`

const WhiteBodyText = styled(BodyText)`
  color: inherit;
`

const Highlight = styled.span`
  color: #00F1BD;
`

/**
 * Compact promo banner shown inside the account-access modal (between the benefits list and the
 * trust indicators) when a customer is eligible for Free Preview auto-enrolment.
 * See useLuxPlusFreePreviewUtils. Figma UX-4738.
 */
function FreePreviewSignupHeader() {
  const intl = useIntl()

  return (
    <Banner>
      <Copy>
        <WhiteBodyText variant="large">
          <FormattedMessage
            id="ULZguNSceZ1JYfnrE8xd"
            defaultMessage="Sign up today to unlock a <bold>free preview</bold> <br></br>of our <bold><highlight>premium membership</highlight></bold>."
            description="Heading on the Free Preview signup modal banner promoting the free membership preview"
            values={{
              bold: (chunks) => <BodyText as="span" variant="large" weight="bold">{chunks}</BodyText>,
              br: () => <br />,
              highlight: (chunks) => <Highlight>{chunks}</Highlight>,
            }}
          />
        </WhiteBodyText>
        <WhiteBodyText variant="small">
          {intl.formatMessage({
            id: 'fOp66jQcWNxYEs3k6TGl',
            defaultMessage: 'No credit card required',
            description: 'Subtext beneath the heading on the Free Preview signup modal banner, noting no payment is needed',
          })}
        </WhiteBodyText>
      </Copy>
      <LuxPlusLogo colour="inherit" height={rem(20)} />
    </Banner>
  )
}

export default FreePreviewSignupHeader
